import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDucEWnbxnuzctVvQdeNyp56Bte5S-0Joc',
    libraries: 'places'
  }
})
